import React from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { GoogleMap } from "components/Map/GoogleMap";
import SweetAlert2 from "react-sweetalert2";
import Api from "shared/resources/Api";
import Header from "components/Headers/Header.js";
import InputMask from "react-input-mask";
import { neighborhood } from "shared/services/PlacesService";
import InputNumber from "react-input-just-numbers";
import gconf from "shared/resources/Gconf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import DataTable from "react-data-table-component";

export default class OvitrampEdit extends React.Component {
  columns = [
    {
      name: "Endereço",
      selector: (row) => row.endereco,
      sortable: true,
    },
    {
      name: "Bairro",
      selector: (row) => row.bairro,
      sortable: true,
      cell: (row) => <div>{row.bairro ? row.bairro : "-"}</div>,
    },
    {
      name: "Setor",
      selector: (row) => row.setor,
      sortable: true,
      cell: (row) => <div>{row.setor ? row.setor : "-"}</div>,
    },
    {
      name: "Ação",
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao"
            title="Escolher"
            onClick={() => {
              this.handleSelectedAddress(row);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
            Escolher
          </Button>
        </div>
      ),
    },
  ];

  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };

  customStyles = {
    table: {
      style: {
        backgroundColor: "#F7FAFC",
      },
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: "15px",
        color: "#000",
        backgroundColor: "#F7FAFC",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      cep: "",
      nome: "",
      responseAddress: "",
      selectedAddress: "",
      tel: "",
      logradouro: "",
      numero: "",
      bairro: "",
      setor: "",
      complemento: "",
      lat: -18.90971,
      lon: -48.261921,
      api: Api.baseURL,
      isMapOk: false,
      isEdicao: false,
      formTitle: "CADASTRAR",
      neighborhood: [],
      sectors: [],
      selectedSector: null,
      selectedNeighborhood: "",
      lado: null,
      quarteirao: 0,
      situacao: "",
      status: "",
      codigo: null,
      swal: { show: false },
      requesting: false,
      isSaving: false,
      ovitramp: null,
      isSuccess: false,
    };

    this.handleSave = this.handleSave.bind(this);
    this.consultarLatLong = this.consultarLatLong.bind(this);
    this.handleSiat = this.handleSiat.bind(this);
    this.createBody = this.createBody.bind(this);
    this.callSave = this.callSave.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  handleSelectedAddress = (row) => {
    console.log(row, "escolheu");
    this.setState(
      {
        selectedAddress: row,
        logradouro: row.endereco ? row.endereco.trim() : "",
        bairro: row.bairro || "",
        setor: row.setor || "",
      },
      () => {
        if (this.state.logradouro && this.state.bairro && this.state.numero) {
          this.consultarLatLong();
        } else if (this.state.logradouro && this.state.bairro) {
          console.warn(
            "Tentando consultar coordenadas sem o número do endereço. A precisão pode ser afetada. Preencha o número e clique em 'Atualizar Coordenadas' se necessário."
          );
        } else {
          console.warn(
            "Dados insuficientes (logradouro, bairro) para consultar coordenadas após selecionar endereço SIAT."
          );
        }
      }
    );
  };

  handleSiat = (event) => {
    event.preventDefault();

    if (!this.state.logradouro || this.state.logradouro.trim().length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Logradouro para consultar o SIAT.",
          type: "warning",
        },
      });
      return false;
    }

    if (this.state.selectedAddress === "") {
      this.setState({ requesting: true, responseAddress: "" });
      this.fetchSiat()
        .then((res) => {
          this.setState({ requesting: false });
          if (res && res.length > 0) {
            this.setState({ responseAddress: res });
          } else {
            this.setState({
              responseAddress: [],
              swal: {
                show: true,
                title: "Atenção",
                text: "Não foram encontrados endereços no SIAT para os parâmetros informados.",
                type: "info",
              },
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching SIAT:", err);
          this.setState({
            requesting: false,
            swal: {
              show: true,
              title: "Erro no SIAT",
              text: "Ocorreu um erro ao buscar endereços no SIAT. Tente novamente.",
              type: "error",
            },
          });
        });
    } else {
      this.setState({
        selectedAddress: "",
        responseAddress: "",
      });
    }
  };

  fetchSiat = async () => {
    let host = `${this.state.api}/siat_enderecos?`;
    let params = {
      endereco: this.state.logradouro.trim(),
      bairro: this.state.bairro ? this.state.bairro.trim() : "",
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => `${esc(k)}=${esc(params[k])}`)
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error("SIAT API response error:", response.status, errorBody);
      throw new Error(`SIAT HTTP error! status: ${response.status}`);
    }
    const body = await response.json();
    return body;
  };

  componentDidMount() {
    neighborhood()
      .then((res) => {
        if (res) {
          this.setState({ neighborhood: res });
        }
      })
      .catch((error) => console.error("Failed to load neighborhoods:", error));

    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.ovitramp
    ) {
      const { ovitramp, os } = this.props.location.state;
      this.setState(
        {
          ovitramp: ovitramp,
          agent: os,
          nome: ovitramp.nome || "",
          lado: ovitramp.lado !== undefined ? ovitramp.lado : null,
          quarteirao:
            ovitramp.quarteirao !== undefined && ovitramp.quarteirao !== null
              ? String(ovitramp.quarteirao)
              : 0,
          bairro: ovitramp.bairro || "",
          tipo: ovitramp.tipo || "",
          status: ovitramp.status || "",
          tel: ovitramp.tel || "",
          matricula: ovitramp.matricula || "",
          logradouro: ovitramp.endereco?.logradouro?.trim() || "",
          numero: ovitramp.endereco?.numero || "",
          complemento: ovitramp.endereco?.complemento || "",
          email: ovitramp.email || "",
          lat: parseFloat(ovitramp.geolocalizacao?.lat) || this.state.lat,
          lon: parseFloat(ovitramp.geolocalizacao?.lon) || this.state.lon,
          isMapOk: !!(
            ovitramp.geolocalizacao?.lat &&
            ovitramp.geolocalizacao?.lon &&
            !isNaN(parseFloat(ovitramp.geolocalizacao.lat)) &&
            !isNaN(parseFloat(ovitramp.geolocalizacao.lon))
          ),
          isEdicao: true,
          formTitle: "EDITAR",
          situacao: ovitramp.situacao || "",
          codigo: ovitramp.codigo || null,
          selectedNeighborhood: ovitramp.bairro || "",
        },
        () => {
          console.log(
            "State initialized for editing. Map will show if coordinates are valid. No automatic geocoding on mount."
          );
        }
      );
    } else {
      this.setState({ formTitle: "CADASTRAR" });
    }
  }

  handleSave(event) {
    event.preventDefault();
    if (this.validateFields()) {
      this.callSave();
    }
  }

  validateFields = () => {
    const { codigo, nome, tel, logradouro, numero, bairro, status, isEdicao } =
      this.state;

    if (
      codigo === undefined ||
      codigo === null ||
      String(codigo).trim().length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Código da Ovitrampa.",
          type: "warning",
        },
      });
      return false;
    }
    if (String(codigo).trim() === "0") {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Código da Ovitrampa não pode ser igual a zero.",
          type: "warning",
        },
      });
      return false;
    }
    if (!nome || nome.trim().length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o nome do proprietário/responsável.",
          type: "warning",
        },
      });
      return false;
    }
    const telDigits = tel.replace(/\D/g, "");
    if (!tel || telDigits.length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Telefone.",
          type: "warning",
        },
      });
      return false;
    }
    if (telDigits.length !== 10 && telDigits.length !== 11) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Preencha o telefone com DDD (10 ou 11 dígitos).",
          type: "warning",
        },
      });
      return false;
    }
    if (!logradouro || logradouro.trim().length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Logradouro.",
          type: "warning",
        },
      });
      return false;
    }
    if (!numero || String(numero).trim().length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Número do endereço.",
          type: "warning",
        },
      });
      return false;
    }
    if (!bairro || bairro.trim() === "") {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Bairro.",
          type: "warning",
        },
      });
      return false;
    }
    if (isEdicao && (!status || status === "")) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Status (Ativo/Inativo).",
          type: "warning",
        },
      });
      return false;
    }
    return true;
  };

  createBody = () => {
    const {
      nome,
      tel,
      setor,
      bairro,
      lado,
      status,
      logradouro,
      quarteirao,
      numero,
      complemento,
      lat,
      lon,
      codigo,
      ovitramp,
      isEdicao,
    } = this.state;
    let payloadOvitrampa;
    if (ovitramp && isEdicao) {
      payloadOvitrampa = {
        nome: nome.trim() !== "" ? nome.trim() : ovitramp.nome,
        tel:
          tel.trim() !== ""
            ? tel.replace(/\D/g, "")
            : ovitramp.tel
            ? ovitramp.tel.replace(/\D/g, "")
            : "",
        setor: setor.trim() !== "" ? setor.trim() : ovitramp.setor || "",
        bairro: bairro.trim() !== "" ? bairro.trim() : ovitramp.bairro || "",
        lado:
          lado !== null && lado !== undefined
            ? String(lado).trim()
            : ovitramp.lado !== undefined
            ? String(ovitramp.lado).trim()
            : null,
        status: status !== "" ? status : ovitramp.status,
        logradouro: logradouro.trim(),
        quarteirao:
          quarteirao !== null && quarteirao !== undefined
            ? parseInt(quarteirao, 10)
            : ovitramp.quarteirao !== undefined
            ? parseInt(ovitramp.quarteirao, 10)
            : 0,
        numero: String(numero).trim(),
        complemento: complemento.trim(),
        geolocalizacao: {
          lat:
            lat !== "" && lat !== null
              ? String(lat)
              : String(ovitramp.geolocalizacao?.lat || this.state.lat),
          lon:
            lon !== "" && lon !== null
              ? String(lon)
              : String(ovitramp.geolocalizacao?.lon || this.state.lon),
        },
        codigo: codigo.trim().toUpperCase(),
      };
    } else {
      payloadOvitrampa = {
        nome: nome.trim(),
        tel: tel.replace(/\D/g, ""),
        bairro: bairro.trim() || "",
        setor: setor.trim() || "",
        lado: lado !== null && lado !== undefined ? String(lado).trim() : null,
        status: "ativo",
        logradouro: logradouro.trim(),
        quarteirao:
          quarteirao !== null && quarteirao !== undefined
            ? parseInt(quarteirao, 10)
            : 0,
        numero: String(numero).trim(),
        complemento: complemento.trim(),
        geolocalizacao: {
          lat: String(lat),
          lon: String(lon),
        },
        codigo: codigo.trim().toUpperCase(),
      };
    }
    return payloadOvitrampa;
  };

  callSave = async () => {
    this.setState({ isSaving: true });
    const bodyPayload = this.createBody();
    const { isEdicao, ovitramp } = this.state;

    const isEditing = isEdicao && ovitramp;
    const method = isEditing ? "PUT" : "POST";
    const url = isEditing
      ? `${Api.baseURL}/ovitrampa/${ovitramp.id}`
      : `${Api.baseURL}/ovitrampa`;

    const requestBody = { ovitrampa: bodyPayload };

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("agToken"),
        },
        body: JSON.stringify(requestBody),
      });

      const responseBody = await response.json();
      this.setState({ isSaving: false });

      if (response.ok && responseBody.sucesso === true) {
        this.setState({
          swal: {
            show: true,
            title: "Sucesso!",
            text: isEditing
              ? "Edição realizada com sucesso!"
              : "Cadastro realizado com sucesso!",
            type: "success",
          },
          isSuccess: true,
        });
      } else {
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text:
              responseBody.msg ||
              (isEditing
                ? "Erro ao editar."
                : "Erro ao cadastrar. Verifique os dados."),
            type: responseBody.sucesso === false ? "error" : "warning",
          },
        });
        console.error(
          "Save error from API:",
          responseBody.erro || responseBody
        );
      }
    } catch (error) {
      this.setState({
        isSaving: false,
        swal: {
          show: true,
          title: "Erro de Conexão",
          text: "Não foi possível salvar os dados. Verifique sua conexão e tente novamente.",
          type: "error",
        },
      });
      console.error("Network or fetch error during save:", error);
    }
  };

  consultarLatLong = () => {
    const { logradouro, numero, bairro } = this.state;

    if (!numero || String(numero).trim().length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Por favor, informe o Número do endereço para atualizar as coordenadas.",
          type: "warning",
        },
      });
      return;
    }

    if (!logradouro || !bairro) {
      this.setState({
        isMapOk: true,
        swal: {
          show: true,
          title: "Atenção",
          text: "Por favor, informe o Logradouro e o Bairro para atualizar as coordenadas.",
          type: "warning",
        },
      });
      console.warn(
        "Tentativa de consultar coordenadas com Logradouro ou Bairro ausentes."
      );
      return;
    }

    const addressParts = [
      logradouro.trim(),
      String(numero).trim(),
      bairro.trim(),
      "Uberlândia",
      "MG",
    ];
    const addressString = addressParts.filter(Boolean).join(", ");

    if (!addressString) {
      console.warn("Cannot geocode empty or incomplete address.");
      this.setState({ isMapOk: true, lat: -18.90971, lon: -48.261921 });
      return;
    }

    const encodedAddress = encodeURIComponent(addressString);
    const components = encodeURIComponent(
      "locality:Uberlândia|administrative_area:MG|country:BR"
    );
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&components=${components}&key=${gconf.key}`;

    console.log("Geocoding address:", addressString);

    fetch(geocodeUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Google Geocoding API error! status: ${response.status}`
          );
        }
        return response.json();
      })
      .then((res) => {
        console.log("Geocoding API Response:", res);
        if (
          res &&
          res.status === "OK" &&
          res.results &&
          res.results.length > 0
        ) {
          const location = res.results[0].geometry.location;
          this.setState({
            lat: parseFloat(location.lat),
            lon: parseFloat(location.lng),
            isMapOk: true,
          });
        } else {
          console.warn(
            "Geocoding failed or no results:",
            res.status,
            res.error_message
          );
          this.setState({
            isMapOk: true,
            swal: {
              show: true,
              title: "Geolocalização",
              text:
                res.status === "ZERO_RESULTS"
                  ? "Endereço não encontrado no mapa."
                  : `Não foi possível obter as coordenadas. (${
                      res.status || "Erro desconhecido"
                    })`,
              type: "warning",
            },
          });
        }
      })
      .catch((err) => {
        console.error("Error during geocoding fetch:", err);
        this.setState({
          isMapOk: true,
          swal: {
            show: true,
            title: "Erro de Rede (Geocoding)",
            text: "Não foi possível conectar ao serviço de geolocalização.",
            type: "error",
          },
        });
      });
  };

  handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  handleCodigoChange = (event) => {
    this.setState({ codigo: event.target.value });
  };

  handleQuarteiraoChange = (event) => {
    this.setState({ quarteirao: event.target.value });
  };

  render() {
    const {
      logradouro,
      numero,
      complemento,
      bairro,
      nome,
      tel,
      lado,
      quarteirao,
      status,
      isMapOk,
      lat,
      lon,
      formTitle,
      requesting,
      isSaving,
      responseAddress,
      selectedAddress,
      codigo,
      isEdicao,
    } = this.state;

    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={() => {
            this.setState({ swal: { show: false } });
            if (this.state.isSuccess && this.props.history) {
              this.props.history.push("/admin/ovitramp");
            }
          }}
        />
        <Header />
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form onSubmit={this.handleSave}>
                    <h6 className="heading-small text-muted mb-4">
                      {formTitle} Ovitrampa
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-codigo"
                            >
                              Código Ovitrampa *
                            </label>
                            <Input
                              className="form-control"
                              id="input-codigo"
                              type="text"
                              placeholder=""
                              value={this.state.codigo || ""}
                              onChange={this.handleCodigoChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-nome"
                            >
                              Nome Proprietário *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-nome"
                              name="nome"
                              type="text"
                              value={nome}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label className="form-control-label" htmlFor="tel">
                              Telefone *
                            </label>
                            <InputMask
                              mask="(99) 99999-9999"
                              value={tel}
                              onChange={this.handleChange}
                              name="tel"
                              id="tel"
                            >
                              {(inputProps) => (
                                <Input
                                  {...inputProps}
                                  className="form-control"
                                  type="text"
                                />
                              )}
                            </InputMask>
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-status"
                            >
                              Status *
                            </label>
                            <Input
                              type="select"
                              name="status"
                              id="input-status"
                              className="form-control"
                              value={status}
                              onChange={this.handleChange}
                              disabled={!isEdicao && formTitle !== "EDITAR"}
                            >
                              <option value="">Selecione...</option>
                              <option value="ativo">Ativo</option>
                              <option value="inativo">Inativo</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-logradouro"
                            >
                              Logradouro *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-logradouro"
                              name="logradouro"
                              placeholder=""
                              type="text"
                              value={logradouro}
                              onChange={this.handleChange}
                              disabled={!!selectedAddress}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Bairro *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-bairro"
                              name="bairro"
                              type="text"
                              maxLength="40"
                              value={bairro}
                              onChange={this.handleChange}
                              disabled={!!selectedAddress}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero"
                            >
                              Número *
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-numero"
                              name="numero"
                              placeholder=""
                              type="text"
                              value={numero}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-complemento"
                            >
                              Complemento
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-complemento"
                              name="complemento"
                              placeholder=""
                              type="text"
                              maxLength={20}
                              value={complemento}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-quarteirao"
                            >
                              Quarteirão
                            </label>
                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value, 10) || 0
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                              placeholder=""
                              value={quarteirao || ""}
                              onChange={this.handleQuarteiraoChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-lado"
                            >
                              Lado
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              name="lado"
                              type="text"
                              maxLength={4}
                              value={lado || ""}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <div className="text-left mt-4 pt-2">
                              <Button
                                className={
                                  this.state.selectedAddress === ""
                                    ? "btn-zoo-alt"
                                    : "btn-zoo"
                                }
                                color="primary"
                                type="button"
                                onClick={this.handleSiat}
                                disabled={requesting || !logradouro.trim()}
                              >
                                {requesting &&
                                  this.state.selectedAddress === "" && (
                                    <Spinner size="sm" className="mr-1" />
                                  )}
                                {this.state.selectedAddress === ""
                                  ? "Consultar Endereço"
                                  : "Alterar Endereço"}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {responseAddress &&
                        responseAddress.length > 0 &&
                        selectedAddress === "" &&
                        !requesting && (
                          <Row className="mb-3">
                            <Col>
                              <DataTable
                                title="Endereços Encontrados (SIAT)"
                                columns={this.columns}
                                data={responseAddress}
                                pagination={true}
                                paginationComponentOptions={
                                  this.defaultComponentOptions
                                }
                                noHeader={true}
                                striped={true}
                                highlightOnHover={true}
                                customStyles={this.customStyles}
                                sortable={true}
                                responsive={true}
                                noDataComponent="Nenhum registro encontrado."
                              />
                            </Col>
                          </Row>
                        )}
                      {requesting && selectedAddress === "" && (
                        <div className="text-center">
                          <Spinner
                            style={{ width: "3rem", height: "3rem" }}
                            color="primary"
                          />
                        </div>
                      )}
                    </div>

                    {isMapOk && (
                      <>
                        <Row className="my-4 justify-content-center">
                          <Col xs="auto">
                            <Button
                              type="button"
                              className="btn btn-primary"
                              title="atualizar"
                              onClick={this.consultarLatLong}
                            >
                              Atualizar Coordenadas
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg="12"
                            style={{ height: "40vh", paddingLeft: 0 }}
                          >
                            <GoogleMap
                              key={`${lat}-${lon}`}
                              lat={parseFloat(lat)}
                              lng={parseFloat(lon)}
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    {!isMapOk && (
                      <Row className="my-4 justify-content-center">
                        <Col xs="auto" className="text-center">
                          <p>
                            Preencha Logradouro, Número e Bairro para carregar o
                            mapa.
                          </p>
                          <Button
                            type="button"
                            color="primary"
                            onClick={this.consultarLatLong}
                            disabled={
                              !logradouro.trim() ||
                              !String(numero).trim() ||
                              !bairro.trim()
                            }
                          >
                            Carregar Mapa
                          </Button>
                        </Col>
                      </Row>
                    )}

                    <hr className="my-4" />
                    {localStorage.getItem("perm") !== "agente" && (
                      <div className="text-center">
                        <Row>
                          <Col className="order-xl-1" xl="12">
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="submit"
                              disabled={this.state.isSaving}
                            >
                              {this.state.isSaving ? (
                                <>
                                  <Spinner size="sm" className="mr-2" />
                                  <span>SALVANDO...</span>
                                </>
                              ) : (
                                <b>
                                  {isEdicao
                                    ? "Salvar Alterações"
                                    : "Cadastrar"}
                                </b>
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}